export default {
    methods: {
        getStoreRole: function(role) {
            switch (role) {
                case 'owner':
                    return this.__('roles.store.owner');
                case 'employee':
                    return this.__('roles.store.employee');
                default:
                    return role;
            }
        }
    }
};